module.exports = __webpack_public_path__ + "static/media/manguera-rojo.392d873b.svg";